import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';

@Component({
  selector: 't4-TrailerHeightWarningDialog',
  templateUrl: 'TrailerHeightWarningDialog.html',
})
export class TrailerHeightWarningDialog extends DialogBase implements OnInit {

  constructor(public dialogRef: MatDialogRef<TrailerHeightWarningDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
      super("TrailerHeightWarningDialog");
    }

  ngOnInit(): void {
  }

    public async close() {
        this.dialogRef.close();
    }
}
